import React, { useState } from "react"
import { ReactModal } from "src/components/ReactModal"


export const usePSYModal = (child: JSX.Element) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const Modal = () => {
    return (
      <ReactModal isOpen={isModalOpen} onDismiss={closeModal}>
        {child}
      </ReactModal>
    )
  }

  return {
    isModalOpen,
    openModal,
    closeModal,
    Modal,
  }
}